
import Vue from 'vue';
import OeamtcSelect, { OeamtcSelectValue } from '@components/new-styleguide/form/OeamtcSelect.vue';
import { Component, Prop } from 'vue-property-decorator';
import { Pilot } from '@clients/myTrips';

@Component({
  name: 'PilotSelect',
  components: {
    OeamtcSelect
  }
})
export default class PilotSelect extends Vue {
  @Prop()
  private value: Pilot;

  @Prop()
  private callbackTripId: string;

  @Prop({ required: true })
  private pilots: Pilot[];

  @Prop({ default: false })
  private disabled: boolean;

  private handleInput(index: number) {
    if (index === 0) {
      this.$emit('input', undefined);
    } else {
      this.$emit('input', this.pilots[index - 1]);
    }
  }

  get valueIndex() {
    if (!this.value) {
      return 0;
    }
    return this.pilots.findIndex(pilot => pilot.id === this.value.id) + 1;
  }

  get pilotOptions(): OeamtcSelectValue[] {
    const mappedPilots = this.pilots.map(pilot => ({
      name: pilot.nickname || (pilot.firstname + (pilot.lastname ? ' ' + pilot.lastname : '')),
      letterIcon: {
        value: pilot.initial,
        color: pilot.color,
        fill: 'white',
        position: 15
      }
    }));

    return [{ name: 'Keine Auswahl' } ,...mappedPilots];
  }
}
